export default __webpack_public_path__ + "static/media/fergus_page_four.b1166ced.svg";